<template>
  <div class='editPostIndex1'>
    <div class='cont'>
      <div v-if="jobInfo">
        <div class="topBox">
          <div class="ipnutBox">
            <div class="title">
              *客户公司
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                  <el-select v-model="jobInfo.setompanylist" placeholder="请选择客户公司" @change="changecompany">
                    <el-option :label="item.customCompanyFullName" v-for="(item,index) in companylist" :key="index"  :value="item.id"></el-option>
                  </el-select>
                </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *职位类型
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-cascader placeholder='请选择职位类型' :options="jobTypeOptions" :show-all-levels="false"
                  @change="changejobType"></el-cascader>
                <span>职位名称：</span>
                <el-input width='300' v-model="jobInfo.positionName" placeholder="请输入职位名称"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *职位标签
            </div>
            <div class="inputCont">
              <el-checkbox-group v-model="jobInfo.jobTags" size="mini">
                <el-checkbox label="优" border>是否预付</el-checkbox>
                <el-checkbox label="独" border>是否独家</el-checkbox>
                <el-checkbox label="急" border>是否加急</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>


          <div class="ipnutBox">
            <div class="title">
              *职位城市
            </div>
            <div class="inputCont">
              <el-select v-model="jobInfo.setcity" multiple filterable allow-create default-first-option placeholder="请选择职位城市" style="width: 500px;">
                <el-option v-for="item in citylist" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
                </el-select>
            </div>
          </div>

          <!-- <div class="ipnutBox">
            <div class="title">
              职位城市
            </div>
            <div class="inputCont">
              <el-checkbox-group v-model="jobInfo.setcity" size="mini">
                <el-checkbox :label="item.value" :key={index} border v-for="(item, index) in citylist" >{{item.value}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div> -->
          <div class="ipnutBox">
            <div class="title">
              工作地址类型
            </div>
            <div class="inputCont">

              <el-radio-group v-model="addressType" size="mini">
                <el-radio label="1" border>国内地址</el-radio>
                <el-radio label="2" border>国外地址</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="ipnutBox" v-if="Number(addressType) === 1">
            <div class="title">
              *工作地址
            </div>
            <div class="inputCont">
              <el-select style="width: 400px" v-model="searchaddres" clearable filterable remote reserve-keyword
                placeholder="请输入地点进行搜索" :remote-method="getSearchSuggestion" :loading="searchloading"
                @clear="searchClear" @change="searchChange">
                <el-option v-for="item in searchSuggestion" :key="item.id"
                  :label="item.address + '(' + item.title + ')'" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="ipnutBox" v-if="Number(addressType) === 2">
            <div class="title">
              *工作地址(国外)
            </div>
            <div class="inputCont">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="jobInfo.workingAddress">
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *所属部门
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.branch" placeholder="请输入职位所属部门"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *月薪范围
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.salaryMin" @change="goeditsalaryMin"
                :min="1"></el-input-number><span> k~ </span>
              <el-input-number size="small" v-model="jobInfo.salaryMax" @change="goeditsalaryMax"
                :min="1"></el-input-number><span> k</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *薪资月份
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.numberSalary" :min="12"
                @change="goeditnumberSalary"></el-input-number><span> 薪</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *年度奖金
            </div>
            <div class="inputCont">
              <el-input-number size="small"  v-model="jobInfo.bonus" :min="0" @change="goeditbonus"
                :step="0.1"></el-input-number><span> w</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *工作年限
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.workingLifeMin" @change="goeditworkingLifeMin" :min="0"
                :max="100"></el-input-number><span> 年~ </span>
              <el-input-number size="small" v-model="jobInfo.workingLifeMax" @change="goeditworkingLifeMax" :min="0"
                :max="100"></el-input-number><span> 年</span>
            </div>
          </div>


          <div class="ipnutBox">
            <div class="title">
              人选必备项
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.personSelEssential" placeholder="请输入职位人选必备项"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              人选核心项
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.personSelCore" placeholder="请输入职位人选核心项"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              人选加分项
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.personSelBonuspoint" placeholder="请输入职位人选加分项"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              面试流程
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.interviewProcess" placeholder="请输入职位面试流程"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              工作时间
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.workHours" placeholder="请输入职位工作时间"></el-input>
              </div>
            </div>
          </div>



          <div class="ipnutBox">
            <div class="title">
              *最低学历
            </div>
            <div class="inputCont">

              <el-radio-group v-model="jobInfo.minEducation" size="mini">
                <el-radio label="博士" border>博士</el-radio>
                <el-radio label="硕士" border>硕士</el-radio>
                <el-radio label="本科" border>本科</el-radio>
                <el-radio label="大专" border>大专</el-radio>
                <el-radio label="高中" border>高中</el-radio>
                <el-radio label="中专/中技" border>中专/中技</el-radio>
                <el-radio label="初中及以下" border>初中及以下</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *面试轮次
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.interviewNumber" :min="0"></el-input-number><span> 轮</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *招聘人数
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.recruitsNumber" :min="0"></el-input-number><span> 人</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *职位有效期
            </div>
            <div class="inputCont">
              <el-date-picker v-model="jobInfo.expirationDate" type="date" :picker-options="pickerOptions"
                placeholder="选择职位有效期">
              </el-date-picker>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *岗位职责 <el-button type="primary" class="sssss" @click="getJd(1)">AI生成</el-button>
            </div>
            <div class="inputCont">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="jobInfo.postDuties">
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *岗位要求 <el-button type="primary" class="sssss" @click="getJd(2)">AI生成</el-button>
            </div>
            <div class="inputCont">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="jobInfo.postReQuirements">
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              特殊说明（非必填）
            </div>
            <div class="inputCont">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="jobInfo.des">
              </el-input>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *佣金比例
            </div>
            <div class="inputCont">
              <el-input-number size="small" v-model="jobInfo.commissionRate" :min="10"
                :max="30"></el-input-number><span> %</span>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *保证期
            </div>
            <div class="inputCont">

              <el-radio-group v-model="jobInfo.warranty" size="mini">
                <el-radio label="一个月" border>一个月</el-radio>
                <el-radio label="两个月" border>两个月</el-radio>
                <el-radio label="三个月" border>三个月</el-radio>
                <el-radio label="四个月" border>四个月</el-radio>
                <el-radio label="五个月" border>五个月</el-radio>
                <el-radio label="六个月" border>六个月</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *分成比例
            </div>
            <div class="inputCont">
              <el-radio-group v-model="jobInfo.payRules" size="mini">
                <el-radio label="1:9" border>1:9</el-radio>
                <el-radio label="2:8" border>2:8</el-radio>
                <el-radio label="3:7" border>3:7</el-radio>
                <el-radio label="4:6" border>4:6</el-radio>
                <el-radio label="5:5" border>5:5</el-radio>
              </el-radio-group>
              <span style="margin-left: 16px">（分成描述：{{ getPayRuleDesc(jobInfo.payRules) }}）</span>
            </div>
          </div>

          <div class="ipnutBox">
            <div class="title">
              *职位情况
            </div>
            <div class="inputCont">
              <el-radio-group v-model="jobInfo.jobPosition" size="mini">
                <el-radio label="新增职位" border>新增职位</el-radio>
                <el-radio label="替补职位" border>替补职位</el-radio>
                <el-radio label="空缺职位" border>空缺职位</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div class="ipnutBox">
            <div class="title">
              *汇报对象
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.reportObject" placeholder="请输入该职位的汇报对象"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *下属人数
            </div>
            <div class="inputCont">
              <div class="posNameBox">
                <el-input width='300' type="number" v-model="jobInfo.subordinates" placeholder="请输入该职位的下属人数"></el-input>
              </div>
            </div>
          </div>
          <div class="ipnutBox">
            <div class="title">
              *是否隐藏公司名称
              <el-switch v-model="isCompany" active-text="隐藏" inactive-text="不隐藏" @change="changeisCompany">
              </el-switch>
            </div>
            <div class="inputCont">

              <div class="posNameBox">
                <el-input width='300' v-model="jobInfo.companyNameCustom" placeholder="请输入匿名之后显示的公司代称"></el-input>
              </div>
            </div>
          </div>
          <div class="btnBox">
            <el-button round @click="postStart">发布职位</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="发布成功" :visible.sync="pesonStatus" width="30%" v-if="personList.length > 0" center>
      <p>发布成功</p>
      <p>你可以邀请猎头为你进行做单</p>
      <div class='personInfo'>
        <div class='cont1'>
          <img class='avater' :src="personList[randomNo].avatarPath" />
          <div class='name'>{{ personList[randomNo].nickname }}</div>
        </div>
        <div class='cont2'
          v-if="personList[randomNo].topListEVoList && personList[randomNo].topListEVoList.length > 0">
          <div class='title'>聘快快行业猎头排行榜</div>
          <div class='rankListItem' v-for="(item) in personList[randomNo].topListEVoList" :key="item.topListNumber">
            <div class='str1'>{item.topName}</div>
            <div class='str2'>{'TOP ' + item.topListNumber}</div>
          </div>
        </div>
        <!-- <div class='cont3' @click="goPInfo(personList[randomNo].id)">
                  查看详情
                </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pesonStatus = false">取 消</el-button>
        <el-button type="primary" @click="goChangePerson">换一个</el-button>
        <el-button type="primary" @click="invZd">邀请做单</el-button>
      </span>
    </el-dialog>

    <el-dialog title="邀请成功" :visible.sync="successBoxStatus" width="30%" center>
      <p style="text-align:center">已邀请Ta帮助企业做单</p>
      <p style="text-align:center">现在你们已经建立沟通机制</p>
      <p style="text-align:center">可随时进行沟通</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="successBoxStatus = false">取 消</el-button>
        <el-button type="primary" @click="goLt">去沟通</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import moment from 'moment'
import { Message } from 'element-ui'

export default {
  name: 'newPost',
  props: {},
  data() {
    return {
      citylist: [],
      companylist: [],     
      jobTypeOptions: [],
      seacherregion: '',
      searchaddres: '',
      searchloading: false,
      searchSuggestion: [],
      pickerOptions: {
        disabledDate(time) {
          let str = moment(time).format('YYYY-MM-DD')
          let star = moment().unix() * 1000
          let last = moment().add(6, 'M').unix() * 1000
          return time.getTime() < star || time.getTime() > last
        },
      },
      successBoxStatus: false,
      rankP: false,
      changeNumber: 0,
      changeLock: false,
      personList: [],
      pesonStatus: false,
      randomNo: 0,
      jobS: {},
      jobInfo: {
        setompanylist: false,
        setcity: [],
        positionName: '',
        salaryMax: '',
        salaryMin: '',
        workingLifeMin: '',
        workingLifeMax: '',
        workingAddress: '',
        postDuties: '',
        postReQuirements: '',
        minEducation: '',
        interviewNumber: '',
        recruitsNumber: '',
        commissionRate: '',
        warranty: '',
        payRules: '5:5',
        bonus: '',
        numberSalary: '',
        minYearSalary: '',
        maxYearSalary: '',
        des: '',
        branch: '',
        jobPosition: '',
        reportObject: '',
        subordinates: '',
        label: '',
        jobTags: [],
        expirationDate: moment().add(1, 'M').format('YYYY-MM-DD'),
        isCompany: '0',
        personSelEssential: '',
        personSelCore: '',
        personSelBonuspoint: '',
        interviewProcess: '',
        workHours: ''

      },
      isCompany: false,
      addressType: '1'
    }
  },
  watch: {},
  created: function () {
     
    if (this.$route.query.isai && this.$route.query.isai === "true") {
       
      let posinfo = JSON.parse(localStorage.getItem('gptJd'))
      this.jobInfo.positionName = posinfo.des1.content
      this.jobInfo.postDuties = posinfo.des2.content
      this.jobInfo.postReQuirements = posinfo.des3.content
    }
    this.getIp()
    this.getJobTypeArray()
    this.getcitylis()
  },
  methods: {
    getJd: function (type) {
      let that = this
      if (this.jobInfo.positionName === '') {
        this.$message({
          message: '请输入职位名称',
          type: 'warning',
        })
      } else {
        this.$message({
          message: '生成中',
          type: 'warning',
          duration: 0
        })
        this.loading = true

        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

        var urlencoded = new URLSearchParams()

        let strrr = `请根据职位名：${this.jobInfo.positionName} 来生成该职位的${type === 1 ? '岗位职责' : '岗位要求'}`

        urlencoded.append('text', strrr)
        urlencoded.append('user', localStorage.getItem('token'))

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow',
        }

        fetch(' https://api.qilinpin.cn/gptapi/api/getJdInfo', requestOptions)
          .then((response) => response.text())
          .then((result) => {
            Message.closeAll()
            console.log(result)
            let posres = JSON.parse(result).msg
            if (type === 1) {
              that.jobInfo.postDuties = posres
            } else if (type === 2) {
              that.jobInfo.postReQuirements = posres
            }
          })
          .catch((error) => {
            that.loading = false
            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
            console.log('error', error)
          })
      }
    },
    changecompany: function (item) {
      let cl = this.companylist
      for (let i in cl) {
        if (item === cl[i].id) {
          this.jobInfo.workingAddress = cl[i].detailedAddress
          this.searchaddres = cl[i].detailedAddress
          for (let j in this.citylist) {
            if (cl[i].inTheCity.indexOf(this.citylist[j].value) >= 0) {
              this.jobInfo.setcity = [this.citylist[j].value]
            }
          }
          this.getSearchSuggestion1()
        }
      }
    },


    getSearchSuggestion1: function (e) {
      let that = this

      this.$jsonp('https://apis.map.qq.com/ws/place/v1/suggestion', {
        keyword: this.searchaddres,
        region: this.seacherregion,
        region_fix: 0,
        key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
        output: 'jsonp',
      })
        .then((res) => {
          if (res.status === 0) {
            that.searchChange1(res.data[0])
          }
        })
        .catch((err) => {
          that.searchloading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },

    searchChange1: function (e) {
      this.jobInfo.cityCode = e.adcode
      this.jobInfo.provinceName = e.province
      this.jobInfo.cityName = e.city
      this.jobInfo.areaName = e.district ? e.district : e.city
      this.jobInfo.location = e.location.lat + ',' + e.location.lng
    },


    getcitylis: function () {
      let that = this
      axios({
          method: 'GET',
          url: Config.path + '/api/common/dict/getDictlist?type=hotCity',
          headers: {
              token: localStorage.getItem('token'),
              'content-type': 'application/json'
          }
      }).then((res) => {
          if (res.data.success === '1') {
              let demoList = res.data.content
              that.citylist = demoList
              that.getTopList()
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
              that.$message.error(res.data.message);
          }
      }).catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getTopList: function () {
      let that = this
      let data = {
          pageNum: 1,
          pageSize: 100,
      }
      axios({
          method: 'POST',
          url: Config.path + '/api/enterprise/custom/company/getList',
          headers: {
              token: localStorage.getItem('token'),
              'content-type': 'application/json'
          },
          data: data,
      }).then((res) => {
          if (res.data.success === '1') {
              let demoList = res.data.content.list
              that.companylist = demoList
              that.jobInfo.setompanylist = demoList[0].id
              that.changecompany(demoList[0].id)
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
              that.$message.error(res.data.message);
          }
      }).catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
      })
    },
    getJobTypeArray: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/treedata/gettreeData',
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.gsArray(res.data.content)
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    gsArray: function (list) {
      for (let i in list) {
        let item = list[i]
        item.label = item.name
        item.value = item.name + ',' + item.code
        if (item.childrenlist) {
          item.children = item.childrenlist
          for (let j in item.children) {
            let item2 = item.children[j]
            item2.label = item2.name
            item2.value = item2.name + ',' + item2.code
            if (item2.childrenlist) {
              item2.children = item2.childrenlist
              for (let k in item2.children) {
                let item3 = item2.children[k]
                item3.label = item3.name
                item3.value = item3.name + ',' + item3.code
              }
            }
          }
        }
      }
      this.jobTypeOptions = list
    },
    changejobType: function (e) {
      this.jobInfo.jobTypeCode = e[e.length - 1].split(',')[1]
      this.jobInfo.jobType = e[e.length - 1].split(',')[0]
    },
    goeditsalaryMin: function (e) {
      if (e <= this.jobInfo.salaryMax) {
        this.jobInfo.salaryMin = e
      } else {
        this.jobInfo.salaryMin = this.jobInfo.salaryMax = e
      }
      this.sumYearSalary()
    },
    goeditsalaryMax: function (e) {
      if (e >= this.jobInfo.salaryMin) {
        this.jobInfo.salaryMax = e
      } else {
        this.jobInfo.salaryMin = this.jobInfo.salaryMax = e
      }
      this.sumYearSalary()
    },
    goeditnumberSalary: function (e) {
      this.jobInfo.numberSalary = e
      this.sumYearSalary()
    },
    goeditbonus: function (e) {
      this.jobInfo.bonus = e
      this.sumYearSalary()
    },
    sumYearSalary: function () {
      (this.jobInfo.minYearSalary =
        (Number(this.jobInfo.salaryMin * this.jobInfo.numberSalary) * 10) /
        100),
        (this.jobInfo.maxYearSalary =
          Number(
            (Number(this.jobInfo.salaryMax * this.jobInfo.numberSalary) * 10) /
            100
          ) + Number(this.jobInfo.bonus))
    },
    goeditworkingLifeMin: function (e) {
      if (e <= this.jobInfo.workingLifeMax) {
        this.jobInfo.workingLifeMin = e
      } else {
        this.jobInfo.workingLifeMin = this.jobInfo.workingLifeMax = e
      }
    },
    goeditworkingLifeMax: function (e) {
      if (e >= this.jobInfo.workingLifeMin) {
        this.jobInfo.workingLifeMax = e
      } else {
        this.jobInfo.workingLifeMin = this.jobInfo.workingLifeMax = e
      }
    },
    getIp: function () {
      let that = this

      this.$jsonp('https://apis.map.qq.com/ws/location/v1/ip', {
        key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
        ip: '220.249.55.194',
        output: 'jsonp',
      })
        .then((res) => {
          if (res.status === 0) {
            this.seacherregion = res.result.ad_info.city
          } else {
            this.seacherregion = '北京市'
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },

    getSearchSuggestion: function (e) {
      let that = this
      that.searchloading = true

      this.$jsonp('https://apis.map.qq.com/ws/place/v1/suggestion', {
        keyword: e,
        region: this.seacherregion,
        region_fix: 0,
        key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
        output: 'jsonp',
      })
        .then((res) => {
          that.searchloading = false
          if (res.status === 0) {
            for (let i in res.data) {
              res.data[i].value =
                res.data[i].address + '(' + res.data[i].title + ')'
              res.data[i].label =
                res.data[i].address + '(' + res.data[i].title + ')'
            }
            that.searchSuggestion = res.data
          }
        })
        .catch((err) => {
          that.searchloading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },

    searchClear: function () {
      this.searchaddres = ''
      this.searchloading = false
      this.searchSuggestion = []
    },

    searchChange: function (e) {
      this.jobInfo.cityCode = e.adcode
      this.jobInfo.provinceName = e.province
      this.jobInfo.cityName = e.city
      this.jobInfo.areaName = e.district ? e.district : e.city
      this.jobInfo.workingAddress = e.address
      this.jobInfo.location = e.location.lat + ',' + e.location.lng
    },
    changeisCompany: function (e) {
      if (e) {
        this.jobInfo.isCompany = '1'
      } else {
        this.jobInfo.isCompany = '0'
      }
    },
    postStart: function () {
      let that = this
      if (
        that.jobInfo.positionName === '' ||
        that.jobInfo.positionName === undefined
      ) {
        that.$message.warning('请输入职位名称')
        return false
      }
      if (
        that.jobInfo.workingAddress === '' ||
        that.jobInfo.workingAddress === undefined
      ) {
        that.$message.warning('请输入工作地点具体位置')
        return false
      }
      if (
        that.jobInfo.postDuties === '' ||
        that.jobInfo.postDuties === undefined
      ) {
        that.$message.warning('请输入岗位职责')
        return false
      }
      if (
        that.jobInfo.postReQuirements === '' ||
        that.jobInfo.postReQuirements === undefined
      ) {
        that.$message.warning('请输入岗位要求')
        return false
      }
      if (
        that.jobInfo.minEducation === '' ||
        that.jobInfo.minEducation === undefined ||
        that.jobInfo.minEducation === '选择学历'
      ) {
        that.$message.warning('请输入该职位的最低学历要求')
        return false
      }
      if (
        that.jobInfo.warranty === '' ||
        that.jobInfo.warranty === undefined ||
        that.jobInfo.warranty === '请选择职位保证期'
      ) {
        that.$message.warning('请选择该职位的保证期')
        return false
      }
      if (
        that.jobInfo.payRules === '' ||
        that.jobInfo.payRules === undefined ||
        that.jobInfo.payRules === '请选择分成比例'
      ) {
        that.$message.warning('请选择该职位的分成比例')
        return false
      }
      if (that.jobInfo.jobTypeCode === '' || !that.jobInfo.jobTypeCode) {
        that.$message.warning('请选择该职位类型')
        return false
      }
      let data = that.jobInfo
      data.companyId = that.$store.state.userStatus.companyVo.id
      debugger
      data.label = data.jobTags.join(':')
      debugger
      data.workPlace = data.setcity.join(',')
      debugger
      data.customCompanyId = data.setompanylist
      debugger
      data.expirationDate = moment(data.expirationDate).format('YYYY-MM-DD') + ' 23:59:59'
      debugger
      delete data.jobTags
      debugger
      delete data.setcity

      axios({
        method: 'POST',
        url: Config.path + '/api/enterprise/jobinfo/replease',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json;charset=UTF-8',
        },
        data,
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.$notify({
              title: '提示',
              message: '职位发布成功',
              type: 'success',
              duration: 1000,
            })
            // that.jobS = res.data.content
            // that.getPinfo(res.data.content.id)
            this.$router.push({
              path: '/myPost',
            })
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.jobInfo.jobTags = []
            that.jobInfo.setcity = []
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },

    getPinfo: function (id) {
      let that = this
      axios({
        method: 'POST',
        url: Api.path + '/api/enterprise/invite/matchingJobTypeUser',
        headers: { token: localStorage.getItem('token') },
        data: {
          pageNum: 1,
          pageSize: 1000,
          jobid: id,
        },
        success: function (res) {
          if (res.data.success === '1') {
            let demoList = []
            demoList = res.data.content.list
            that.personList = demoList
            if (demoList.length > 0) {
              that.pesonStatus = true
            } else {
              that.$router.push({
                path: '/myPost',
              })
            }
          }  else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                } else {
            that.$message.error(res.data.message)
          }
        },
        fail: function () {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        },
      })
    },

    invZd: function () {
      let that = this
      const personList = this.personList
      const randomNo = this.randomNo
      const jobS = this.jobS
      const id = jobS.id
      if (jobS.status !== 1) {
        that.$message.error('该职位暂未上架')
        return false
      }
      axios({
        method: 'POST',
        url: Api.path + '/api/enterprise/invite/invite',
        headers: {
          'content-type': 'application/json',
          token: localStorage.getItem('token'),
        },
        data: {
          jobId: id,
          invitationSource: '1',
          candidateUserIdList: [personList[randomNo].id],
        },
        success: function (res) {
          if (res.data.success === '1') {
            that.invGb(personList[randomNo].id)
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        },
        fail: function () {
          that.interShowStatus = true
        },
      })
    },

    invGb: function (getId) {
      let that = this
      axios({
        method: 'POST',
        url: Api.path + '/api/common/mes/sendMsgReply',
        header: { 'content-type': 'application/json' },
        data: {
          sendUserId: that.$store.state.userStatus.id,
          replyUserId: getId,
        },
        success: function (res) {
          if (res.data.success === '1') {
            that.pesonStatus = false
            that.successBoxStatus = true
          } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
            that.$message.error(res.data.message)
          }
        },
        fail: function () {
          that.setState({
            interShowStatus: true,
          })
        },
      })
    },

    goChangePerson: function () {
      let that = this
      let changeNumber = this.changeNumber
      let personList = this.personList
      let randomNo = this.randomNo
      let rand = Math.ceil(Math.random() * personList.length) - 1
      if (personList.length === 1) {
        that.$message.warning('暂时没有更多匹配该职位的猎头了')
      } else if (rand === randomNo && randomNo < personList.length - 1) {
        rand = rand + 1
      } else if (rand === randomNo && randomNo === personList.length - 1) {
        rand = rand - 1
      }
      if (changeNumber === 2 || changeNumber === personList.length - 1) {
        that.changeNumber = changeNumber + 1
        that.changeLock = true
        that.successBoxStatus = false
        that.pesonStatus = true
        that.randomNo = rand
      } else {
        that.changeNumber = changeNumber + 1
        that.successBoxStatus = false
        that.pesonStatus = true
        that.randomNo = rand
      }
    },

    goLt: function (index, e) {
      this.successBoxStatus = false
    },
    getPayRuleDesc: function (payRules) {
      const parts = payRules.split(':')
      const p = 1
      const a = (+parts[0] - p) * 10 + '%'
      const b = +parts[1] * 10 + '%'
      return `平台${p * 10}% 发单${a} 做单${b}`
    },
  },
  mounted: function () { },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.editPostIndex1 {
    min-width: 100vw;
    flex: 1;
    padding-top: 1px;
    position: relative;
    background-color: #e6e6e6;
    overflow-x: auto;

  .personInfo {
    width: 516px;
    margin: 31px auto 0 auto;
    min-height: 246px;
    border-radius: 34px;
    box-sizing: border-box;
    border: 2px solid #5dc2d0;

    .cont1 {
      height: 170px;
      background-color: rgba($color: #5dc1cf, $alpha: 0.2);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .avater {
        display: block;
        width: 82px;
        height: 82px;
        border-radius: 100%;
      }

      .name {
        font-size: 25px;
        color: #898989;
        padding-top: 8px;
      }
    }

    .cont2 {
      padding-bottom: 19px;

      .title {
        font-size: 25px;
        color: #888888;
        text-align: center;
        padding: 19px 0 11px 0;
      }

      .rankListItem {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 4px 0;

        .str1 {
          font-size: 25px;
          color: #888888;
        }

        .str2 {
          font-size: 25px;
          color: #5dc1cf;
        }
      }
    }

    .cont3 {
      border-top: 2px solid #5dc2d0;
      height: 76px;
      text-align: center;
      line-height: 76px;
      color: #5dc2d0;
      font-size: 25px;
    }
  }

  .cont {
        width: 90vw;
        background-color: #fff;
        border-radius: 20px;
        margin: 30px auto 0 auto; 
        box-sizing: border-box;
        padding: 30px;
        height: calc(100%);
        border-radius: 8px;
        box-sizing: border-box;
    // overflow: hidden;
    display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;

    .topBox {
      .name {
        color: #5dc2d0;
        font-size: 32px;
        font-weight: bold;
        padding-bottom: 10px;
        border-bottom: 2px solid #5dc2d0;

        span {
          font-size: 12px;
        }
      }

      .info {
        padding-top: 10px;
        font-size: 12px;
        color: #5dc2d0;
        width: max-content;
        border-bottom: 2px solid #5dc2d0;
        padding-bottom: 10px;
      }

      .ipnutBox {
        * {
          // background-color: transparent;
          color: #5dc2d0;
          // outline: none;
        }

        .title {
          color: #5dc2d0;
          padding: 20px 0;

          .sssss{
              color: #ffffff;
              margin-left: 20px;
              cursor: pointer;
              span{
                color: #ffffff;
              }
            }
        }

        .inputCont {
          .posNameBox {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            span {
              margin: 0 10px 0 20px;
            }

            .el-input {
              width: 300px;
            }
          }
        }
      }

      .btnBox {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        button {
          background-color: transparent;
          color: #5dc2d0;
        }
      }
    }
  }
}
</style>
